/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SelectInstrumentRequest} from '@cash-web/protos/squareup/cash/cashlynxflow/api/v2/select_instrument.pb'
import {SelectInstrumentResponse} from '@cash-web/protos/squareup/cash/cashlynxflow/api/v2/select_instrument.pb'


export const selectInstrumentV2 = (request: SelectInstrumentRequest, options?: CashRequestOptions) => post<SelectInstrumentRequest, SelectInstrumentResponse>("/cash-app/instrument/v2.0/select-instrument", request, {...options, rejectOnError: true })